import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-btn-exportar-excel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './btn-exportar-excel.component.html',
  styleUrls: ['./btn-exportar-excel.component.scss'],
})
export class BtnExportarExcelComponent {
  @Input() disabled: boolean = false;
  @Input() label: string = '';
  @Input() icon: string = '';
  @Output() exportar = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.exportar.emit();
    }
  }
}
